var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[_c('h1',{staticClass:"hero"},[_vm._v("Estadísticas")]),_c('h2',[_vm._v("Pagos (mes natural)")]),_c('div',{staticClass:"stats-group"},[_c('div',{staticClass:"small-stats"},[_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: ((_vm.stats.paymentAmount / 100) + "€"),
					name: 'Total',
					icon: 'mdi-cash',
				}}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.paymentCount,
					name: 'Pagos completados',
					icon: 'mdi-credit-card-check',
				},"color":"success"}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.rejectedPaymentCount,
					name: 'Pagos rechazados',
					icon: 'mdi-credit-card-remove',
				},"color":"error"}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.pendingPaymentCount,
					name: 'Pagos pendientes',
					icon: 'mdi-credit-card-clock',
				},"color":"info lighten-2"}})],1),_c('div',{staticClass:"other-stats"},[_c('v-card',{staticClass:"rounded-lg stats-card"},[_c('v-sheet',{attrs:{"color":"secondary"}},[_c('h2',{staticClass:"accent--text graph-title"},[_vm._v(" Pagos realizados este mes ")]),_c('v-sparkline',{attrs:{"labels":_vm.stats.paymentsPerDay.days,"value":_vm.stats.paymentsPerDay.payments,"color":"accent","line-width":"2","padding":"16","smooth":"","show-labels":""}})],1)],1)],1)]),_c('h2',[_vm._v("Carreras")]),_c('div',{staticClass:"stats-group"},[_c('div',{staticClass:"small-stats"},[_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.raceCount,
					name: 'Carreras activas',
					icon: 'mdi-run',
				}}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.freeRaceCount,
					name: 'Carreras Gratis',
					icon: 'mdi-currency-usd-off',
				}}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.paidRaceCount,
					name: 'Carreras de pago',
					icon: 'mdi-currency-usd',
				}}})],1),_c('div',{staticClass:"other-stats"},[_c('v-card',{staticClass:"content rounded-lg stats-card"},[_c('h1',[_vm._v("Últimas carreras creadas")]),_c('ul',_vm._l((_vm.stats.lastRaces),function(race){return _c('li',{key:race.id},[_vm._v(" "+_vm._s(race.name)+" ")])}),0)])],1)]),_c('h2',[_vm._v("Usuarios")]),_c('div',{staticClass:"stats-group"},[_c('div',{staticClass:"small-stats"},[_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.userCount,
					name: 'Usuarios Registrados',
					icon: 'mdi-account-check',
				}}}),_c('small-stat',{staticClass:"small-stat",attrs:{"data":{
					number: _vm.stats.verificationPendingUserCount,
					name: 'Usuarios sin verificar',
					icon: 'mdi-account-alert',
				},"color":"warning"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }